var _g, _rect, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqBtnClosed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3048_332242)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.76465,
    y: 1.76489,
    width: 172.941,
    height: 56.4706,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76465 44.9414C1.76465 49.3597 5.34637 52.9414 9.76465 52.9414H52C56.4182 52.9414 59.9999 49.3597 59.9999 44.9414V9.76493C59.9999 5.34665 56.4182 1.76494 51.9999 1.76494H9.76464C5.34636 1.76494 1.76465 5.34666 1.76465 9.76494V44.9414Z",
    fill: "url(#paint0_linear_3048_332242)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3048_332242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.29395 11.0588C5.29395 8.8497 7.08481 7.05884 9.29395 7.05884H50.7057C52.9148 7.05884 54.7057 8.8497 54.7057 11.0588V45.4118C54.7057 47.6209 52.9148 49.4118 50.7057 49.4118H9.29395C7.08481 49.4118 5.29395 47.6209 5.29395 45.4118V11.0588Z",
    fill: "url(#paint1_linear_3048_332242)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.882353,
    y: 0.882353,
    width: 58.2353,
    height: 58.2353,
    rx: 11.1176,
    stroke: "black",
    strokeWidth: 1.76471
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6167 30.4883L19.9917 30.4883",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.467041,
    width: 60,
    height: 60,
    rx: 12,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3048_332242",
    x: 4.41159,
    y: 6.17648,
    width: 51.1763,
    height: 44.1177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.441176,
    result: "effect1_foregroundBlur_3048_332242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3048_332242",
    x1: 35.8113,
    y1: 8.2521,
    x2: 35.8113,
    y2: 52.9414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204071,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6B69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3048_332242",
    x1: 34.182,
    y1: 44.0431,
    x2: 34.182,
    y2: 7.05884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204071,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6B69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3048_332242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqBtnClosed);
export default __webpack_public_path__ + "static/media/faq-btn-closed.38d412519c608b019eeaa71ef2a19a92.svg";
export { ForwardRef as ReactComponent };